import { render, staticRenderFns } from "./DonationsSponsorships.vue?vue&type=template&id=22b6f8da&"
import script from "./DonationsSponsorships.vue?vue&type=script&lang=js&"
export * from "./DonationsSponsorships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports